import { useRef, useState } from 'react';

import { useDeleteTaskCommentMutation } from '../api/useDeleteTaskCommentMutation';

import type { ICommentMessage } from '@entities/message';

export const useTaskCommentDeletion = (taskId: string) => {
    const mutation = useDeleteTaskCommentMutation(taskId);
    const [commentId, setCommentId] = useState<ICommentMessage['id'] | null>(null);
    const deletingRef = useRef(false);

    const openConfirmation = (id: ICommentMessage['id']) => {
        if (deletingRef.current) return;
        mutation.reset();
        setCommentId(id);
    };

    const closeConfirmation = () => {
        if (deletingRef.current) return;
        setCommentId(null);
        mutation.reset();
    };

    const confirmDeletion = () => {
        if (commentId === null || deletingRef.current) return;

        deletingRef.current = true;
        mutation.mutate(commentId, {
            onSettled: () => {
                deletingRef.current = false;
                setCommentId(null);
            },
        });
    };

    return {
        isOpen: commentId !== null,
        isPending: mutation.isPending,
        isError: mutation.isError,
        error: mutation.isError ? mutation.error : null,
        openConfirmation,
        closeConfirmation,
        confirmDeletion,
        closeError: mutation.reset,
    };
};
